import axios from "axios";
import { FETCH_STATUS, FETCH_STATUS_RANGE, HANDLE_ERRORS, LOADING_MODE } from "./types";
import authorizeRequest from '../helpers/authorize-request';
import alarms from '../constants/alarms';
import { map, get, forIn } from 'lodash';
import BASE_URL from '../helpers/base-url';
import { formatResults } from '../helpers/getStatus';

const getStatusLogic = (dispatch, alarms, from, to) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'status' } });

      return await axios
        .all(map(alarms, ({ id }) => {
          // https://api.edf-sf.com/v1/28/ems/status/1?id=1&from=1547665649222&to=1547752049000
          const queryString = from && to ? `?from=${from}&to=${to}` : '';
          return axios
            .get(
              `${BASE_URL}/api/external/status/${id}${queryString}`,
              authorizeRequest()
            )
            .catch(error => {
              console.error(error);
              reject(error);
            });
        }))
        .catch(error => {
          console.error(error);
          reject(error);
        })
        .then(results => {
          dispatch({
            type: HANDLE_ERRORS,
            payload: { message: "", open: false }
          });
          resolve(results);
          setTimeout(() => {
            dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'status' } });
          });
        });
    } catch (error) {
      console.error("error fetching status", error);
      dispatch({
        type: HANDLE_ERRORS,
        payload: { message: error.message, open: true }
      });
      dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'status' } });
      reject(error);
    }
  });
};

export const getCurrentStatus = () => async dispatch => {
  getStatusLogic(dispatch, alarms.status.filter(({ id }) => id === 211))
    .then(async results => {
      await dispatch({
        type: FETCH_STATUS,
        payload: {
          data: {
            results: map(results, result => get(result, 'data.results[0]')).filter(value => value)
          }
        }
      });
    });
};

const excludedColumns = {
  bits: true,
  values: true
};

const extractHeaders = (line, prefix, headers) => {
  forIn(line, (value, key) => {
    const excluded = excludedColumns[key];
    const columnKey = `${prefix}${key}`;
    const currentPrefix = `${columnKey}.`;

    if (!excluded && typeof value === 'object') {
      extractHeaders(value, currentPrefix, headers);

    } else if (
      !excluded &&
      !headers.find(({ key }) => key === columnKey)
    ) {

      headers.push({ label: columnKey, key: columnKey });
    }
  });
};

const getHeaders = data => data.forEach(line => extractHeaders(line, '', []));

const flattenStatus = status => status.forEach(status =>
  status.values && status.values.forEach(({ title, value }) => status[title] = value)
);

export const getStatus = (from, to) => async dispatch => {
  dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'alarms' } });

  getStatusLogic(dispatch, alarms.status, from, to)
    .catch(() => dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'alarms' } }))
    .then(async results => {

      const filtered = map(results, result => get(result, 'data.results')).filter(value => value);

      const status = formatResults(filtered);
      flattenStatus(status);
      const headers = getHeaders(status);

      await dispatch({
        type: FETCH_STATUS_RANGE,
        payload: {
          status,
          headers
        }
      });

      setTimeout(() => {
        dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'alarms' } });
      });

    });
};



// WEBPACK FOOTER //
// ./src/actions/getStatus.js